<template>
  <div>
    <a-card class="application-detail">
      <a-page-header :title="appData.name" :sub-title="appData.platform">
        <div class="application-detail-main">
          <div class="left">
            <a-avatar class="logo" :size="64" shape="square" :src="appData.logo" />
          </div>
          <div class="right">
            <a-descriptions size="small" :column="2">
              <a-descriptions-item label="创建时间"> {{ appData.created_time }} </a-descriptions-item>
              <a-descriptions-item label="更新时间"> {{ appData.updated_time }} </a-descriptions-item>
              <a-descriptions-item label="应用介绍"> {{ appData.introduction }} </a-descriptions-item>
            </a-descriptions>
          </div>
        </div>
        <template slot="footer">
          <a-tabs v-model="activeKey">
            <a-tab-pane key="1" tab="版本管理" />
          </a-tabs>
        </template>
      </a-page-header>
    </a-card>
    <a-card v-if="activeKey === '1'" class="tab-content-card" size="small">
      <version-list :app-key="appKey" :versions="appData.versions" />
    </a-card>
  </div>
</template>
<script>
import VersionList from '@/pages/tools/application/components/VersionList';
import { applicationDetail } from '@/api/tools/application';
export default {
  components: { VersionList },
  props: {
    appKey: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      activeKey: '1',
      appData: {
        versions: []
      }
    };
  },
  watch: {
    appKey() {
      this.getApplicationDetail();
    }
  },
  created() {
    this.getApplicationDetail();
  },
  methods: {
    getApplicationDetail() {
      if (this.appKey) {
        applicationDetail({ app_key: this.appKey }).then(res => {
          this.appData = res.data;
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.application-detail .ant-card-body {
  padding: 16px 16px 0 16px;
}

/deep/.ant-page-header {
  padding: 0px;
  .ant-page-header-footer {
    margin-top: 8px;
  }
  .ant-page-header-footer .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab {
    font-size: 14px;
  }
}
.application-detail-main {
  .left {
    float: left;
    width: 80px;
  }
  .right {
    float: left;
    width: calc(~'100% - 80px');
  }
}
.tab-content-card {
  margin-top: 16px;
}
</style>
